<template>
  <div class="view privileges-view">
    <Privileges />
  </div>
</template>

<script>
import Privileges from '../components/Privileges.vue';

export default {
  name: 'PrivilegesView',
  components: {
    Privileges,
  },
};
</script>

<style>
.privileges-view {
  display: flex!important;
}
</style>
